import {
  generateDynamicCalendarColumns,
  getPortfolioStatisticsRows,
} from 'pages/Cases/PortfolioConstruction/Summary/PerformanceReport';

import { Grid } from '@mui/material';
import { ChartBox, SlideParagraph, SlideTitle } from 'features/slides';
import { PortfolioStatisticsBarChart } from 'pages/Cases/components/PortfolioStatisticsBarChart';
import SummaryPerformanceTable from 'pages/Cases/components/SummaryPerformanceTable';
import { portfolioStatisticsChartFilter } from 'pages/Cases/PortfolioConstruction/Summary/PerformanceReport';
import React from 'react';

export type CalendarYearReturnsProps = {
  readonly filteredPerformance: any;
  readonly rowsCalendarYearReturnsTable?: boolean;
};

export function CalendarYearReturns({
  filteredPerformance,
  rowsCalendarYearReturnsTable,
}: CalendarYearReturnsProps): React.ReactElement {
  const filteredData = portfolioStatisticsChartFilter({
    filteredPerformance,
    name: 'calendar_yr_returns',
  });

  const dynamicColumns = generateDynamicCalendarColumns(filteredData);

  return (
    <Grid
      container
      flexDirection="column"
      gap={0}
      sx={{
        width: '100%',
        padding: '10px',
      }}
    >
      <Grid
        container
        sx={{
          marginBottom: '6px',
        }}
      >
        <SlideTitle>Calendar Year Returns</SlideTitle>
      </Grid>

      <ChartBox>
        <PortfolioStatisticsBarChart
          data={portfolioStatisticsChartFilter({
            filteredPerformance,
            name: 'calendar_yr_returns',
          })}
          ytdFinal={true}
          height={rowsCalendarYearReturnsTable ? 400 : 500}
          isWithAnimation={false}
          formatChart={{
            label: 'Return (%)',
          }}
        />
      </ChartBox>
      {rowsCalendarYearReturnsTable && (
        <Grid sx={{ width: '100%', backgroundColor: '#fff' }}>
          <SummaryPerformanceTable
            rows={getPortfolioStatisticsRows(filteredData)}
            columns={dynamicColumns}
          />
        </Grid>
      )}
      <SlideParagraph
        style={{
          marginBottom: '10px',
          marginTop: '10px',
          fontSize: '13px',
        }}
      >
        Source: TIFIN Sage
      </SlideParagraph>
    </Grid>
  );
}
